import { FC } from 'react';

import SplitModalHeader from './components/SplitModalHeader';
import SplitModalBody from './components/SplitModalBody';
import SplitModalFooter from './components/SplitModalFooter';

import { useSplitModal } from './context/SplitModalContext';

import '../Modals.scss';
import CustomLoading from '../../CustomLoading';

const SplitModal: FC = () => {
  const { data } = useSplitModal();

  return (
    <>
      <SplitModalHeader />
      <SplitModalBody />
      <SplitModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default SplitModal;
